import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Loading from "default/components/Loading";
import Error from "default/components/Error";
import TicketNotFound from "default/components/TicketNotFound";
import { useUrlParams } from "hooks/useUrlParams";
import useSystemTicketState from "hooks/useSystemTicketState";

import OmagunLayout from "../components/OmagunLayout";
import OmagunTitle from "../components/OmagunTitle";

const withLanguage = (path, lng) => `${path}${path.includes("?") ? "&" : "?"}lng=${lng}`;

const remainingDays = (expiresAt) => {
  const milliseconds = new Date(expiresAt).getTime() - Date.now();
  return Math.max(0, Math.ceil(milliseconds / (24 * 60 * 60 * 1000)));
};

export default function MyPage() {
  const navigate = useNavigate();
  const { soulId, lng, work } = useUrlParams();
  const { t } = useTranslation(["common", work]);
  const { ticketState, hasPurchased, isLoading, isError } = useSystemTicketState(soulId);

  if (isLoading) {
    return <OmagunLayout page="MyPage"><Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}><Loading /></Box></OmagunLayout>;
  }
  if (isError) {
    return <OmagunLayout page="MyPage"><Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}><Error /></Box></OmagunLayout>;
  }
  if (!hasPurchased || !ticketState) {
    return (
      <OmagunLayout page="MyPage">
        <Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center", px: 3 }}>
          <TicketNotFound onClick={() => navigate(withLanguage(`/${work}/tickets?soul_id=${soulId}`, lng))} />
        </Box>
      </OmagunLayout>
    );
  }

  return (
    <OmagunLayout page="MyPage">
      <Box sx={{ px: 2, pb: 10 }}>
        <OmagunTitle>My Page</OmagunTitle>
        <Box
          sx={{
            border: "1px solid rgba(255,255,255,.22)",
            backgroundColor: "rgba(0,0,0,.62)",
          }}
        >
          <Box
            component="img"
            src="/omagun/mypage/todoroki-mypage.webp"
            alt="轟二矢"
            sx={{ display: "block", width: "100%", aspectRatio: "16 / 9", objectFit: "cover" }}
          />
          <Box sx={{ px: 2.5, py: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 2 }}>
              <Typography sx={{ fontFamily: '"TamanegiKaishoGeki", serif', fontSize: 20 }}>
                轟二矢
              </Typography>
              <Typography sx={{ fontFamily: '"Noto Serif JP", serif', fontSize: 11 }}>
                残り交流日数 <Box component="strong" sx={{ fontSize: 18 }}>{remainingDays(ticketState.expires_at)}</Box>日
              </Typography>
            </Box>
            <Typography sx={{ mt: 2.5, fontFamily: '"Noto Serif JP", serif', fontSize: 13, lineHeight: 1.8 }}>
              {t(`${work}:characterSituation.todoroki.description`)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </OmagunLayout>
  );
}
